// extracted by mini-css-extract-plugin
export default {"layoutContainer":"Layout_layoutContainer__A+Btx","layoutMain":"Layout_layoutMain__FWYRT"};